import { createSelector } from 'reselect';

const getApiAccessState = (state: any) => state.apiAccessReducer;

export const getApiAccessRoles = createSelector(getApiAccessState, (state) => state.roles);
export const getApiAccessRolesLoading = createSelector(
    getApiAccessState,
    (state) => state.rolesLoading,
);
export const getApiAccessUsers = createSelector(getApiAccessState, (state) => state.users);
export const getApiAccessTotalRecords = createSelector(
    getApiAccessState,
    (state) => state.totalRecords,
);
export const getApiAccessUsersLoading = createSelector(
    getApiAccessState,
    (state) => state.usersLoading,
);
export const getApiAccessCreateUserLoading = createSelector(
    getApiAccessState,
    (state) => state.createUserLoading,
);
export const getApiAccessCreateUserSuccess = createSelector(
    getApiAccessState,
    (state) => state.createUserSuccess,
);
export const getApiAccessCreateUserResult = createSelector(
    getApiAccessState,
    (state) => state.createUserResult,
);
export const getApiAccessUpdateUserLoading = createSelector(
    getApiAccessState,
    (state) => state.updateUserLoading,
);
export const getApiAccessUpdateUserSuccess = createSelector(
    getApiAccessState,
    (state) => state.updateUserSuccess,
);
export const getApiAccessUpdatePasswordLoading = createSelector(
    getApiAccessState,
    (state) => state.updatePasswordLoading,
);
export const getApiAccessUpdatePasswordSuccess = createSelector(
    getApiAccessState,
    (state) => state.updatePasswordSuccess,
);
export const getApiAccessUpdatePasswordResult = createSelector(
    getApiAccessState,
    (state) => state.updatePasswordResult,
);
export const getApiAccessUserDetails = createSelector(
    getApiAccessState,
    (state) => state.userDetails,
);
export const getApiAccessUserLoading = createSelector(
    getApiAccessState,
    (state) => state.userLoading,
);
export const getApiAccessUserEndpoints = createSelector(
    getApiAccessState,
    (state) => state.endpoints,
);
export const getApiAccessUserEndpointsLoading = createSelector(
    getApiAccessState,
    (state) => state.endpointsLoading,
);
